export const getBaseStreamUrls = () => {
  return {
    VIDEO: process.env.REACT_APP_VIDEO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/video',
    AUDIO: process.env.REACT_APP_AUDIO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/audio',
    THERMAL: process.env.REACT_APP_THERMAL_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/thermal',
    PUBLISH_AUDIO: process.env.REACT_APP_PUBLISH_AUDIO_STREAM_URL || 'rtsp://publisher:Smartlight123@164.52.201.205:8554/Cam-001/app'
  };
};

export const RTSP_URLS = getBaseStreamUrls();

/**
 * Format any device input (e.g. 1, 5, '001', 'VC-002', 'Cam-005', 'Smartlight-005') to a 3-digit string like '001', '005'
 */
export const formatDeviceId = (deviceId) => {
  if (deviceId === undefined || deviceId === null || deviceId === '') return '001';
  const str = String(deviceId).trim();
  const digitsMatch = str.match(/\d+/);
  if (digitsMatch) {
    return String(digitsMatch[0]).padStart(3, '0');
  }
  return '001';
};

/**
 * Clean and normalize any custom prefix name
 */
export const cleanPrefixName = (prefix) => {
  if (!prefix) return 'Cam';
  const str = String(prefix).trim();
  const cleaned = str.replace(/[^a-zA-Z0-9_-]/g, '');
  return cleaned || 'Cam';
};

/**
 * Generate stream URL replacing {prefix}-XXX with {targetPrefix}-{formattedId}
 * @param {string} streamType - 'video' | 'thermal' | 'audio'
 * @param {string|number} deviceId - device ID e.g. 1, '001'
 * @param {string} prefix - e.g. 'Cam', 'Smartlight', or any custom prefix added by admin
 */
export const getDeviceStreamUrl = (streamType, deviceId, prefix = 'Cam') => {
  const baseUrls = getBaseStreamUrls();
  const formattedId = formatDeviceId(deviceId);
  const typeKey = String(streamType || 'video').toUpperCase();
  const rawUrl = baseUrls[typeKey] || baseUrls.VIDEO;
  const targetPrefix = cleanPrefixName(prefix);

  if (/[a-zA-Z0-9_-]+-\d+/i.test(rawUrl)) {
    return rawUrl.replace(/[a-zA-Z0-9_-]+-\d+/gi, `${targetPrefix}-${formattedId}`);
  }
  return rawUrl.replace(/\/\d+/g, `/${targetPrefix}-${formattedId}`);
};

export const getDevicePublishAudioUrl = (deviceId, prefix = 'Cam') => {
  const baseUrls = getBaseStreamUrls();
  const formattedId = formatDeviceId(deviceId);
  const targetPrefix = cleanPrefixName(prefix);
  const rawUrl = baseUrls.PUBLISH_AUDIO;

  if (/[a-zA-Z0-9_-]+-\d+/i.test(rawUrl)) {
    return rawUrl.replace(/[a-zA-Z0-9_-]+-\d+/gi, `${targetPrefix}-${formattedId}`);
  }
  return rawUrl.replace(/\/\d+/g, `/${targetPrefix}-${formattedId}`);
};

export const getCameraStreamsForDevice = (deviceId, prefix = 'Cam') => {
  const formattedId = formatDeviceId(deviceId);
  const targetPrefix = cleanPrefixName(prefix);
  return [
    {
      id: 'video',
      label: 'Video',
      name: `Video Stream (${targetPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('video', deviceId, targetPrefix)
    },
    {
      id: 'thermal',
      label: 'Thermal',
      name: `Thermal Stream (${targetPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('thermal', deviceId, targetPrefix)
    },
    {
      id: 'audio',
      label: 'Audio',
      name: `Audio Stream (${targetPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('audio', deviceId, targetPrefix)
    }
  ];
};

export const CAMERA_STREAMS = getCameraStreamsForDevice('001');

export default RTSP_URLS;

